const initialState = {
  isLoadingApi: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {

  case "setIsLoadingApi":
    return { ...state, ...payload }

  default:
    return state
  }
}
